import React from 'react';
import defaultImg from '../../../../../assets/images/default-article.png';

export const OrganizationCard = ({ orgData, heartButtonFunction, params }) => {
	const org = orgData.organization;
	const logo = orgData.logo;
	const userAndContactCount = orgData.user_and_contact_count;
	const interestAreas = orgData.interest_areas;
	const followed = orgData.followed;

	const orgLocation = (city, state) => {
		if (city && state) {
			return city + ', ' + state;
		}
		if (city) {
			return city;
		}
		if (state) {
			return state;
		}
		return '';
	};

	const blurb = (description, interestAreas) => {
		let tValue = 270;
		if (!interestAreas) {
			return description.substring(0, tValue);
		}
		if (interestAreas.length == 1) tValue = 200;
		if (interestAreas.length == 2) tValue = 120;
		if (interestAreas.length > 2) tValue = 90;

		return description.substring(0, tValue) + '...';
	};

	return (
		<div
			className="columns small-12 dashboard-card organization-card card"
			style={{ overflow: 'visible' }}
		>
			{heartButtonFunction ? (
				<div className="follow-container">
					{followed ? (
						<div
							className="primary-button follow-button"
							onClick={heartButtonFunction}
						>
							<p>Following</p>
						</div>
					) : (
						<div
							className="secondary-button follow-button"
							onClick={heartButtonFunction}
						>
							<p>Follow</p>
						</div>
					)}
				</div>
			) : null}
			<a
				href={'/organizations/' + org.slug + params}
				className="follow-btn-link"
			>
				<div className="row media-container">
					<img
						src={logo ? logo : defaultImg}
						alt={`${org.operating_name} Logo`}
					/>
				</div>
				<div className="meta-container">
					{orgLocation(org.city, org.state)}
				</div>
				<div className="title-container">
					<strong>
						{org.legal_name ? org.legal_name : org.operating_name}
					</strong>
				</div>
				<div className="row collapse qualities-container">
					<div className="columns small-6 text-left">
						<i className="fa fa-eye"></i>
						{` ${org.view_count}`}
					</div>
					<div className="columns small-6 text-left">
						<i className="fas fa-user"></i>
						{` ${userAndContactCount}`}
					</div>
				</div>
				<div className="details-container">
					{blurb(org.description, interestAreas)}
				</div>
			</a>
			<div className="tags-container row">
				<div className="column button-group">
					{interestAreas.slice(0, 3).map((interest_area, index) => {
						return (
							<div className="tag-button" key={index}>
								<a
									href={
										'/organizations?interest_area=' +
										interest_area.id
									}
								>
									<p className="body-font">
										{interest_area.name}
									</p>
								</a>
							</div>
						);
					})}
					{interestAreas.length > 3 ? (
						<i className="fas fa-ellipsis-h" />
					) : null}
				</div>
			</div>
		</div>
	);
};
